import { render, staticRenderFns } from "./PageRedirectLoaderDialog.vue?vue&type=template&id=1816204c&scoped=true"
import script from "./PageRedirectLoaderDialog.vue?vue&type=script&lang=js"
export * from "./PageRedirectLoaderDialog.vue?vue&type=script&lang=js"
import style0 from "./PageRedirectLoaderDialog.vue?vue&type=style&index=0&id=1816204c&prod&lang=css"
import style1 from "./PageRedirectLoaderDialog.vue?vue&type=style&index=1&id=1816204c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816204c",
  null
  
)

export default component.exports